// src/pages/ResetPasswordPage.js
// Accessible at /reset-password?token=<raw>&type=vendor  or  ?type=malladmin

import React, { useState } from 'react';
import api from '../services/api';

export default function ResetPasswordPage() {
  const params   = new URLSearchParams(window.location.search);
  const token    = params.get('token') || '';
  const type     = params.get('type')  || 'vendor';
  const isMall   = type === 'malladmin';

  const [password,  setPassword]  = useState('');
  const [confirm,   setConfirm]   = useState('');
  const [done,      setDone]      = useState(false);
  const [error,     setError]     = useState('');
  const [loading,   setLoading]   = useState(false);

  const endpoint = isMall ? '/mall/reset-password' : '/auth/reset-password';

  if (!token) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)' }}>
      <div style={{ textAlign:'center', color:'var(--text2)' }}>
        <div style={{ fontSize:40, marginBottom:12 }}>❌</div>
        <div style={{ fontWeight:700 }}>Invalid reset link</div>
        <div style={{ fontSize:13, marginTop:8, marginBottom:20 }}>No token found in the URL.</div>
        <button className="btn btn-primary" onClick={() => window.location.href = '/'}>Back to Login</button>
      </div>
    </div>
  );

  const handle = async () => {
    if (!password) return setError('Enter a new password.');
    if (password.length < 8) return setError('Password must be at least 8 characters.');
    if (password !== confirm) return setError('Passwords do not match.');
    setLoading(true); setError('');
    try {
      await api.post(endpoint, { token, newPassword: password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)' }}>
      <div style={{ background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:40, width:400 }}>

        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ fontSize:32, marginBottom:8 }}>🔐</div>
          <div style={{ fontSize:20, fontWeight:700, color:'var(--accent)' }}>Set New Password</div>
          <div style={{ fontSize:13, color:'var(--text2)', marginTop:4 }}>
            {isMall ? 'Mall Admin' : 'Vendor'} account
          </div>
        </div>

        {done ? (
          <div style={{ textAlign:'center' }}>
            <div style={{ fontSize:40, marginBottom:16 }}>✅</div>
            <div style={{ fontWeight:700, marginBottom:8 }}>Password updated!</div>
            <div style={{ fontSize:13, color:'var(--text2)', marginBottom:24 }}>You can now log in with your new password.</div>
            <button className="btn btn-primary" style={{ width:'100%', padding:13 }} onClick={() => window.location.href = '/'}>
              Go to Login
            </button>
          </div>
        ) : (
          <>
            <div style={{ marginBottom:16 }}>
              <div className="section-label" style={{ marginBottom:6 }}>New password</div>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="At least 8 characters"
                autoFocus
              />
            </div>
            <div style={{ marginBottom:24 }}>
              <div className="section-label" style={{ marginBottom:6 }}>Confirm password</div>
              <input
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                placeholder="Repeat your password"
                onKeyDown={e => e.key === 'Enter' && handle()}
              />
            </div>

            {error && (
              <div style={{ color:'var(--red)', fontSize:13, marginBottom:14, textAlign:'center' }}>{error}</div>
            )}

            <button className="btn btn-primary" style={{ width:'100%', padding:13 }} onClick={handle} disabled={loading}>
              {loading ? 'Updating...' : 'Update Password'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
